import { render, staticRenderFns } from "./CampaignItemSetupTime.vue?vue&type=template&id=bdd96dfe&scoped=true&"
import script from "./CampaignItemSetupTime.vue?vue&type=script&lang=js&"
export * from "./CampaignItemSetupTime.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItemSetupTime.vue?vue&type=style&index=0&id=bdd96dfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd96dfe",
  null
  
)

export default component.exports